import {createAsyncThunk} from "@reduxjs/toolkit"

export const setProfile = createAsyncThunk("/setProfile",async ({data}) => data)